import { useEffect } from "react";
import { useAssistant } from "@/context/AssistantContext";
import { Conversation } from "@/components/assistant/Conversation";
import { Sessions } from "@/components/assistant/Sessions";

/** Full-screen assistant workspace: history on the left, one wide conversation in the middle. */
export default function AssistantPage() {
  const { mode, setMode } = useAssistant();
  useEffect(() => {
    if (mode !== "closed") setMode("closed"); // never two surfaces at once
  }, [mode, setMode]);
  return (
    <div className="flex h-[calc(100vh-3rem)] min-h-0" data-testid="assistant-page">
      <aside className="hidden w-[260px] shrink-0 border-r border-border/70 bg-sidebar lg:flex lg:flex-col dark:border-white/5">
        <Sessions className="h-full" />
      </aside>
      <div className="min-w-0 flex-1">
        <Conversation variant="full" />
      </div>
    </div>
  );
}
